import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';
import { normalizeSystemTransactionListResponse } from 'lib/normalization';
import {
  clearSystemTransactionMapStatus,
  setTransactionMappingStatus,
  setTransactionNoteStatus,
} from 'lib/transactions';
import { NoteAction } from 'store/notes';
import { SystemTransactionHandleAction, TransactionHandleAction } from 'store/transactions';
import { SystemTransaction } from 'types/dto';
import { SortDirection } from 'types/sort';
import { RequestStatus } from 'types/transport';
import { SystemTransactionAction } from './actions';

const entitiesReducer = createReducer<Record<string, SystemTransaction>>({})
  .handleType(SystemTransactionAction.Clear, () => ({}))
  .handleType(SystemTransactionAction.ListResponse, (state, action) => {
    const [entities] = normalizeSystemTransactionListResponse(action.payload);
    return entities;
  })
  .handleType(SystemTransactionHandleAction.ArchiveResult, (state, action) => {
    const { systemTransactions = [], transactionId } = action.payload;
    return setTransactionMappingStatus(state, systemTransactions, transactionId, 'IGNORED');
  })
  .handleType(NoteAction.Response, (state, action) => {
    const { transactionId } = action.payload;
    return setTransactionNoteStatus(state, [transactionId], true);
  })
  .handleType(TransactionHandleAction.MatchResult, (state, action) => {
    const { systemTransactions = [], transactionId } = action.payload;
    return setTransactionMappingStatus(state, systemTransactions, transactionId, 'MATCHED');
  })
  .handleType(TransactionHandleAction.AutoMatchResult, (state, action) => {
    const { systemTransactions = [], transactionMappingId } = action.payload;
    return setTransactionMappingStatus(state, systemTransactions, transactionMappingId, 'MATCHED');
  })
  .handleType(SystemTransactionHandleAction.RestoreResponse, (state, action) =>
    clearSystemTransactionMapStatus(state, action.payload),
  )
  .handleType(TransactionHandleAction.UnmatchResponse, (state, action) =>
    clearSystemTransactionMapStatus(state, action.payload),
  );

const idsReducer = createReducer<Array<string>>([])
  .handleType(SystemTransactionAction.Clear, () => [])
  .handleType(SystemTransactionAction.ListResponse, (state, action) => {
    const [, ids] = normalizeSystemTransactionListResponse(action.payload);
    return ids;
  });

const queryReducer = createReducer<string>('')
  .handleType(SystemTransactionAction.Clear, () => '')
  .handleType(SystemTransactionAction.Query, (state, action) => action.payload);

const selectedReducer = createReducer<Array<string>>([])
  .handleType(SystemTransactionAction.Clear, () => [])
  .handleType(SystemTransactionAction.Select, (state, action) => action.payload);

const sortDirReducer = createReducer<Nullable<SortDirection>>(null).handleType(
  SystemTransactionAction.Sort,
  (state, action) => action.payload.direction ?? null,
);

const sortKeyReducer = createReducer<Nullable<string>>(null).handleType(
  SystemTransactionAction.Sort,
  (state, action) => action.payload.key ?? null,
);

const statusReducer = createReducer<RequestStatus>(RequestStatus.None)
  .handleType(SystemTransactionAction.Clear, () => RequestStatus.None)
  .handleType(SystemTransactionAction.Error, () => RequestStatus.Error)
  .handleType(SystemTransactionAction.ListRequest, () => RequestStatus.Reading)
  .handleType(SystemTransactionAction.ListResponse, () => RequestStatus.Success);

export default combineReducers({
  entities: entitiesReducer,
  ids: idsReducer,
  query: queryReducer,
  selected: selectedReducer,
  sortDir: sortDirReducer,
  sortKey: sortKeyReducer,
  status: statusReducer,
});
